
import React,{ useEffect } from 'react';
import { QuoteListingSearchFilter } from './QuoteFilter/QuoteListingSearchFilter';
import { SubmittedQuoteList } from './SubmittedQuoteList';
import { SubmittedQuoteFilterList } from './SubmittedQuoteFilterList';
import { useObjCommonFilterStore } from "../../hooks/objCommonFilter";
import ReusableDiv from 'src/helper/ReusableDiv';
import { useQuoteStore } from 'src/hooks/quote';

export function QuoteListing() {
    const [{ filter_list }, {}, {}] = useObjCommonFilterStore();
    const [{ }, { }, { destroy_cart_quote_active_session }] = useQuoteStore();
    useEffect(() => {
        destroy_cart_quote_active_session();
    }, []);
    return (
        <>
            <div id="main" className="">
                {ReusableDiv.QuoteHeader()}
                <div id="submitted-pcnquote-page" className="pcn-page container quote-tabs mb-4">
                    <QuoteListingSearchFilter/>
                    <div className='quote-tabs-content'>
                        {Object.keys(filter_list)?.length > 0 ?
                          <SubmittedQuoteFilterList/> :
                          <SubmittedQuoteList/>
                        }
                        <div className='mx-3 mb-3 mt-2 font-arial font-13'>
                            <strong>Terms & Conditions</strong><br/>
                            <div className='mt-2'>
                                Quotes are valid for 30 days unless otherwise noted. Unless there is an applicable
                                written
                                agreement
                                between Avnet and Buyer, any quote issued by Avnet and Avnet's acceptance of any order
                                are
                                subject to
                                Avnet's Terms and Conditions of Sale found <a className='text-darkgreen'
                                                                              href='https://www.avnet.com/wps/portal/us/about-avnet/terms-and-conditions-of-sale/'
                                                                              target="_blank"
                                                                              rel="noreferrer">here</a> . Avnet
                                objects to any different or additional terms.
                            </div>
                            <div className='mt-2'>
                                Chinese tariff data is provided solely for informational purposes to assist in
                                estimating
                                Chinese
                                tariff impact. Avnet cannot validate its accuracy or completeness and it relies upon
                                historical
                                sales
                                data that excludes future sales.
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );

}
